// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.bockdammMug',
  title: 'hardCoded.title.bockdammMug',
  slug: titleToSlug('hardCoded.title.bockdammMug'),
  catalog: {
    title: 'hardCoded.catalog.title.bockdammMug',
    catalogMedia,
    price: numberToCurrency('18'),
    color: '#0a0a0a'
  }
}
